import { render } from "./HeroSettingNotification.vue?vue&type=template&id=2bc1ccde&scoped=true"
import script from "./HeroSettingNotification.vue?vue&type=script&lang=js"
export * from "./HeroSettingNotification.vue?vue&type=script&lang=js"

import "./HeroSettingNotification.vue?vue&type=style&index=0&id=2bc1ccde&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc1ccde"]])

export default __exports__